import { useEffect, useMemo, useRef, useState } from "react"

import { useEditor } from "@craftjs/core"

import { useEditing } from "@/modules/cms/views/post/components/builder/context"

export default function useAutoSelectEditing() {
  const { value: editing } = useEditing()
  const { actions: { history: { ignore } } } = useEditor()
  const ignoreRef = useRef(ignore())

  ignoreRef.current = ignore()

  useEffect(() => {
    const { current: { deserialize } } = ignoreRef

    if (editing) {
      const { definition: { craft } } = editing
      deserialize(craft)
    } else {
      deserialize({})
    }
  }, [editing])
}
